import Pause from './Pause';
export default Pause;